// tslint:disable-next-line:import-name
import MenuProductCardContainer from './MenuProductCard';
import MenuProductCardUI from './MenuProductCardUI';

export { IMenuCardPlan } from './types';

const MenuProductCard = {
    Container: MenuProductCardContainer,
    UI: MenuProductCardUI
};

export default MenuProductCard;
